'use client';

import { useEffect, useRef } from 'react';
import { getCookie } from 'cookies-next';
import { usePathname } from 'next/navigation';
import parseUserV2 from 'utils/parseUserV2';
import isUntrackablePath from 'app/_lib/utils/isUntrackablePath';
import MetaPixelService from 'services/metaPixel.service';

const currentUser = () =>
  parseUserV2(getCookie('user_token') as string | undefined);

/** Identity only, for a logged-in user, and never on the home page. */
export default function MetaPixelInitializer() {
  const pathname = usePathname();
  const pathnameRef = useRef(pathname);

  useEffect(() => {
    pathnameRef.current = pathname;
    if (isUntrackablePath(pathname)) return;

    const user = currentUser();
    if (!user.email) return;

    const pixel = MetaPixelService.getInstance();
    pixel.changeUser(user);
    pixel.trackUserIdentified();
  }, [pathname]);

  // Catches a login that happens without a reload, such as the Piano modal.
  useEffect(() => {
    const interval = setInterval(() => {
      if (document.hidden || isUntrackablePath(pathnameRef.current)) {
        return;
      }

      const user = currentUser();
      if (!user.email) return;

      // Meta only transmits identity on an event, so a fresh login needs one.
      const pixel = MetaPixelService.getInstance();
      if (pixel.changeUser(user)) pixel.trackUserIdentified();
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return null;
}
